<template>
  <div class="wrapper">
    <div class="header_row">
      <div class="title_group">
        <h2 class="title">打工度假代辦服務應注意事項</h2>
        <p>確認相關文件，保障您的安全</p>
      </div>
    </div>

    <div class="hotline_card">
      <div class="hotline_item">
        <p class="label">緊急服務專線</p>
        <p class="number">0800-085-095</p>
      </div>
      <div class="hotline_item">
        <p class="label">急難救助全球免付費專線</p>
        <p class="number">880-0885-0885</p>
      </div>
      <a
        class="usage_link"
        title="[另開新視窗]急難救助全球免付費專線撥打使用說明"
        href="https://www.boca.gov.tw/cp-87-2121-7a5da-1.html"
        target="_blank"
        rel="noopener noreferrer"
      >
        撥打使用說明
        <InfoCircleFilled />
      </a>
    </div>

    <div class="notice_list">
      <div v-for="item in noticeList" :key="item.title" class="notice_card">
        <div class="notice_banner">
          <img :src="item.image" alt="" />
        </div>
        <div class="notice_body">
          <h3 class="notice_title">{{ item.title }}</h3>
          <p v-for="(line, idx) in item.desc" :key="idx" class="notice_desc">
            {{ line }}
          </p>
          <div class="notice_actions">
            <a class="download_btn" :href="item.file" :download="item.fileName">
              下載 <DownloadOutlined />
            </a>
            <router-link v-if="item.link" class="more_btn" :to="item.link">
              更多內容 <RightOutlined />
            </router-link>
            <a v-else class="more_btn" href="javascript:void(0)">
              更多內容 <RightOutlined />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import {
  InfoCircleFilled,
  DownloadOutlined,
  RightOutlined,
} from "@ant-design/icons-vue";
import bannerBlue from "../img/img-banner_1.png";
import bannerGreen from "../img/img-banner_2.png";

const noticeList = [
  {
    title: "打工度假代辦服務應注意事項",
    desc: [
      "查詢最新代辦服務定型化契約與相關法規。",
      "提供權益手冊下載與合規代辦業者名單。",
    ],
    image: bannerBlue,
    link: "/fraud_prevention/notice/agency",
    file: "/files/labor-holiday-work-agency-notice.pdf",
    fileName: "打工度假代辦服務應注意事項.pdf",
  },
  {
    title: "度假打工遇有我國違反(非)法私立就業服務機構申訴資訊",
    desc: [
      "查詢最新代辦服務定型化契約與相關法規。",
      "提供權益手冊下載與合規代辦業者名單。",
    ],
    image: bannerGreen,
    link: "/fraud_prevention/notice/complaint",
    file: "/files/labor-holiday-work-complaint-info.odt",
    fileName: "度假打工遇有我國違反(非)法私立就業服務機構申訴資訊.odt",
  },
];

export default defineComponent({
  name: "FraudNotice",
  components: {
    InfoCircleFilled,
    DownloadOutlined,
    RightOutlined,
  },
  setup() {
    return { noticeList };
  },
});
</script>

<style lang="scss" scoped>
.wrapper {
  text-align: left;
  margin: 20px 0 100px;
}

.header_row {
  margin-bottom: 24px;

  .title_group {
    text-shadow: 2px 2px 5px #232323;
    .title {
      color: rgba(238, 238, 238, 1);
      margin-bottom: 8px;
      font-weight: 500;
      font-size: 36px;
      line-height: 45px;
      letter-spacing: 0px;
    }
    p {
      color: rgba(238, 238, 238, 1);
      font-size: 18px;
    }
  }
}

.hotline_card {
  @include flex_between();
  background-color: #fff;
  border: 1px solid var(--border, rgba(226, 232, 240, 1));
  padding: 20px 30px;
  margin-bottom: 40px;
  @include md {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .hotline_item {
    .label {
      font-size: 16px;
      font-family: "Noto Sans TC";
      color: #000000d9;
    }
    .number {
      font-size: 24px;
      font-weight: 900;
      color: #024d73;
    }
  }

  .usage_link {
    @include flex_center();
    color: rgba(2, 77, 115, 1);
    font-size: 16px;
    :deep(svg) {
      margin-left: 6px;
      width: 24px;
      height: 24px;
    }
  }
}

.notice_list {
  display: flex;
  gap: 32px;
  @include md {
    flex-direction: column;
  }

  .notice_card {
    flex: 1;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border: 1px solid var(--border, rgba(226, 232, 240, 1));
    padding: 16px;

    .notice_banner {
      width: 100%;
      height: 200px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }

    .notice_body {
      display: flex;
      flex-direction: column;
      flex: 1;
      padding: 16px;
      .notice_title {
        font-family: "Noto Sans TC";
        font-size: 20px;
        color: #000000d9;
        margin-bottom: 20px;
      }

      .notice_desc {
        font-family: "Noto Sans TC";
        font-size: 16px;
        color: #64748b;
        line-height: 1.6;
      }

      .notice_actions {
        display: flex;
        gap: 12px;
        margin-top: auto;
        padding-top: 20px;
        @include xs {
          flex-direction: column;
        }

        .download_btn,
        .more_btn {
          @include flex_center();
          flex: 1;
          padding: 12px 16px;
          font-size: 16px;
          font-weight: bold;
          white-space: nowrap;
          :deep(svg) {
            margin-left: 8px;
          }
        }

        .download_btn {
          background-color: $main_color;
          color: #fff;
          &:hover {
            opacity: 0.85;
          }
        }

        .more_btn {
          background-color: #fff;
          border: 1px solid $hr_gray;
          color: $black_color;
          &:hover {
            opacity: 0.85;
          }
        }
      }
    }
  }
}
</style>
